import { TextareaAutosize } from '@material-ui/core'
import { useTranslate } from 'react-admin'
const TextAreaInput = ({
  source,
  label,
  required,
  type,
  record,
  setPayload,
  payload,
  setErrors,
  errors,
  ...props
}) => {
  const translate = useTranslate()
  return (
    <>
      <TextareaAutosize
        required={required}
        error={required && errors.find((item) => item.id == props.id)}
        label={translate(label, { _: label })}
        fullWidth
        style={{
          minWidth: '100%',
          minHeight: '70px',
        }}
        defaultValue={record[source]}
        onChange={(e) => {
          if (required && !e.target.value) {
            setErrors(() => {
              return errors.map((err) => {
                return err.id == props.id
                  ? {
                      id: props.id,
                      source: source,
                      type: type,
                      label: label,
                    }
                  : err
              })
            })
          } else {
            setErrors(() => {
              return errors.filter((item) => item.id !== props.id)
            })
          }
          setPayload({ ...payload, [source]: e.target.value })
        }}
      />
    </>
  )
}
export default TextAreaInput
